import styles from '../../styles/Footer.module.css';
import logoImage from '../../assets/images/logo.png';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        {/* 로고 & 회사 정보 */}
        <div className={styles.section}>
          <img src={logoImage} alt="olym 로고" className={styles.logo} />
          <p className={styles.company}>
            (주)베네피셜 엔터프라이즈
          </p>
          <p className={styles.info}>대표자: 김 휘</p>
          <p className={styles.info}>사업자등록번호: 260-87-02649</p>
          <p className={styles.info}>주소: 서울특별시 양천구 중앙로36길 36, 101호</p>
          <p className={styles.copyright}>
            Copyright © 2025 Beneficial Enterprise. All rights reserved.
          </p>
        </div>

        {/* 연락처
        <div className={styles.section}>
          <h4>Contact</h4>
          <p>📞 010-8671-0401</p>
          <p>✉️ kwh@beneficial.co.kr</p>
        </div> */}

        {/* 링크 */}
        <div className={styles.section}>
          <h4>Legal</h4>
          <ul className={styles.links}>
            <li><a href="https://olym-beneficial.notion.site/2364365aa24c80ce8b3cec5342fe3ba4" target="_blank" rel="noopener noreferrer">개인정보처리방침</a></li>
            <li><a href="https://olym-beneficial.notion.site/1bc4365aa24c80b49251ec2cdc905e02" target="_blank" rel="noopener noreferrer">이용약관</a></li>
          </ul>
        </div>

        <div className={styles.section}>
          <h4>Customer</h4>
          <ul className={styles.links}>
            <li><a href="/#hero">고객용 앱</a></li>
          </ul>
        </div>

        <div className={styles.section}>
          <h4>Guide</h4>
          <ul className={styles.links}>
            <li><a href="https://olym-beneficial.notion.site/2ba4365aa24c81158a98dc17e34a9c52" target="_blank" rel="noopener noreferrer">관리자 가이드</a></li>
          </ul>
        </div>

        <div className={styles.section}>
          <h4>센터 입점</h4>
          <ul className={styles.links}>
            <li><a href="https://admin.olym.kr/onboarding" target="_blank" rel="noopener noreferrer">무료로 시작하기</a></li>
          </ul>
        </div>

        <div className={styles.section} id="admin-app">
          <h4>Admin App</h4>
          <ul className={styles.links}>
            <li><a href="https://apps.apple.com/app/id6757894768" target="_blank" rel="noopener noreferrer">App Store</a></li>
            <li><a href="https://play.google.com/store/apps/details?id=com.beneficial.olym.admin.app" target="_blank" rel="noopener noreferrer">Google Play</a></li>
          </ul>
        </div>
      </div>

      {/* 하단 메시지 */}
      <div className={styles.bottom}>
        <p>한 번 설정하면 스스로 운영합니다</p>
      </div>
    </footer>
  );
}
